import React from "react";

export default function WhyChooseUs() {
    return (
        <section className="py-24 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <h2 className="text-3xl md:text-4xl font-display font-extrabold text-primary mb-12">
                    Mengapa Memilih Kami?
                </h2>

                {/* Content Split */}
                <div className="flex flex-col lg:flex-row gap-16 items-center">
                    <div className="lg:w-1/2 relative h-[500px] w-full flex items-center justify-center">
                        {/* Decorative background element */}
                        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-[radial-gradient(#2563eb_1px,transparent_1px)] [background-size:20px_20px] opacity-10 -z-10 rounded-full blur-3xl"></div>

                        <div className="relative w-full h-full max-w-md">
                            {/* Bottom Layer */}
                            <div className="absolute top-0 left-0 w-[80%] h-[70%] z-0 transform -rotate-6 transition-all duration-500 hover:-rotate-2 hover:scale-105">
                                <img
                                    alt="Modern Data Center"
                                    className="w-full h-full object-cover rounded-2xl shadow-xl border-4 border-white dark:border-slate-800"
                                    src="https://images.unsplash.com/photo-1544197150-b99a580bb7a8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
                                />
                            </div>

                            {/* Middle Layer */}
                            <div className="absolute top-[15%] left-[10%] w-[80%] h-[70%] z-10 transform rotate-3 transition-all duration-500 hover:rotate-0 hover:scale-105 shadow-2xl">
                                <img
                                    alt="Network Infrastructure"
                                    className="w-full h-full object-cover rounded-2xl shadow-2xl border-4 border-white dark:border-slate-800"
                                    src="https://images.unsplash.com/photo-1551703599-6b3e8379aa8c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
                                />
                            </div>

                            {/* Top Layer */}
                            <div className="absolute bottom-0 right-0 w-[80%] h-[70%] z-20 transform -rotate-3 transition-all duration-500 hover:rotate-2 hover:scale-110 shadow-2xl">
                                <img
                                    alt="Global Network Solution"
                                    className="w-full h-full object-cover rounded-2xl shadow-2xl border-4 border-white dark:border-slate-800"
                                    src="https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="lg:w-1/2 text-left">
                        <p className="text-slate-600 dark:text-slate-400 text-lg leading-relaxed mb-6">
                            Ghandiva IT Solutions diposisikan sebagai pemimpin dalam layanan
                            teknologi inovatif, berdedikasi untuk mengoptimalkan operasi bisnis
                            melalui transformasi digital. Berkantor pusat di pusat teknologi modern,
                            kami membawa pengalaman global selama puluhan tahun.
                        </p>
                        <p className="text-slate-600 dark:text-slate-400 text-lg leading-relaxed">
                            Dengan lokasi strategis di seluruh dunia, kami menyediakan rekayasa perangkat lunak
                            khusus, infrastruktur cloud yang aman, dan kerangka keamanan siber yang kuat
                            yang memberdayakan organisasi untuk unggul di era digital.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
